interface EditorBlock {
	type: string;
	data?: {
		text?: string;
	};
}

export function hasTextContent(content: string | undefined | null): boolean {
	if (!content) return false;
	if (content[0] === '{' || content[0] === '[') {
		const contentJson = JSON.parse(content);
		if (!contentJson || !Array.isArray(contentJson.blocks)) return false;
		const blocks = (contentJson.blocks as EditorBlock[]).filter(
			(block: EditorBlock) =>
				block.type !== 'paragraph' || (block.data?.text?.trim().length ?? 0) > 0
		);
		return blocks.length > 0;
	} else {
		return content.trim().length > 0;
	}
}
